import { MultiLangText } from "src/utils/types"
import { DiscussionCategory } from "../../entities/discussionCategory"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	name: MultiLangText
	icon: string
	color: string
}

export async function discussionCategoryAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/discussion/category/add/v1"
	const requester = new ApiRequester<RequestDataShape, DiscussionCategory>(endpoint)
	return await requester.sendRequest(payload, token)
}
